<template>
  <div>
    <div>
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Danh sách"
            :link="[
              {
                text: 'Đồng phục',
                href: '../uniformes',
              },
            ]"
          />
        </div>
        <div class="flex-center">
          <v-btn depressed dark color="primary" @click="newDialog = !newDialog">
            <v-icon>mdi-plus</v-icon> Thêm đồng phục
          </v-btn>
        </div>
      </div>

      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <UniformFilter @onFilterChanged="onFilterChange" />
      </v-card>

      <v-card outlined class="mx-4 elevation-0">
        <UniformDataTable ref="uniformDataTable" />
      </v-card>
      <UniformNewDialog :state="newDialog" @updated="onFilterChange()" />
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
// import { mapGetters } from 'vuex'
import UniformDataTable from '@/modules/uniform/UniformDataTable.vue'
import UniformFilter from '@/modules/uniform/UniformFilter.vue'

export default {
  components: {
    Breadcrumbs,
    UniformDataTable,
    UniformFilter,
    UniformNewDialog: () => import('@/modules/uniform/UniformNewDialog.vue'),
  },
  props: {},
  data() {
    return {
      newDialog: false,
      type: '',
    }
  },
  computed: {},
  methods: {
    async refresh(query) {
      this.$refs.uniformDataTable.refresh(query)
    },
    onFilterChange(query) {
      this.refresh(query)
    },
  },
  created() {
    this.status = this.statusDefault
  },
}
</script>
<style scoped></style>
